import { createNullableProvideInject } from '@collector/shared-ui'
import { EventStatusId } from '@collector/sportsapi-client-legacy'

export const [provideEventStatuses, injectEventStatuses] =
  createNullableProvideInject<EventStatusId[]>('eventStatuses')
